export enum PACKAGE_COLUMN_NAME {
  PACKAGE_ID = "packageId",
  SHIPMENT_CLIENT_NAME = "shipmentClientName",
  PARCEL_CENTER_LOCATION_NAME = "parcelCenterLocationName",
  FDP_COMPANY_NAME = "fdpCompanyName",
  SERVICE_TYPE_NAME = "serviceTypeName",
  FDP_ID = "fdpId",
  SHIPMENT_EXTERNAL_PARTNER_SHIPMENT_ID = "shipmentExternalPartnerShipmentId",
  SHIPMENT_EXTERNAL_ORDER_ID = "shipmentExternalOrderId",
  TRACKING_NUMBER = "trackingNumber",
  BAR_CODE = "barCode",
  RECEIVED_DATE = "receivedDate",
  PLANNED_DELIVERY_DATE = "plannedDeliveryDate",
  PARCEL_ARRIVAL_DATE = "parcelArrivalDate",
  DELIVERY_DATE = "deliveryDate",
  TWO_MAN = "twoMan",
  DESKTOP = "desktop",
  SHIPMENT_DELIVERY_INSTRUCTIONS = "shipmentDeliveryInstructions",
  SHIPMENT_RECIPIENT_ADDRESS_TYPE = "shipmentRecipientAddressType",
  SIGNATURE_REQUIRED = "signatureRequired",
  SHIPMENT_RECIPIENT_NAME = "shipmentRecipientName",
  SHIPMENT_RECIPIENT_PHONE = "shipmentRecipientPhone",
  SHIPMENT_RECIPIENT_ADDRESSLINE_1 = "shipmentRecipientAddressLine1",
  SHIPMENT_RECIPIENT_ADDRESSLINE_2 = "shipmentRecipientAddressLine2",
  SHIPMENT_RECIPIENT_CITY = "shipmentRecipientCity",
  SHIPMENT_RECIPIENT_STATE = "shipmentRecipientState",
  SHIPMENT_RECIPIENT_ZIP = "shipmentRecipientZip",
  PACKAGE_VOLUME = "packageVolume",
  PACKAGE_LENGTH = "packageLength",
  PACKAGE_WIDTH = "packageWidth",
  PACKAGE_HEIGHT = "packageHeight",
  PACKAGE_WEIGHT = "packageWeight",
  PACKAGE_CONTENTS = "packageContents",
  STATUS_DATE = "statusDate",
  STATUS = "status",
  SHIPMENT_ID = "shipmentId",
  PARCEL_CENTER_ID = "parcelCenterId",
  SHIPMENT_CLIENT_ID = "shipmentClientId",
  CREATED_ON = "createdOn",
  CREATED_BY = "createdBy",
  UPDATED_ON = "updatedOn",
  UPDATED_BY = "updatedBy",
}

export enum PACKAGE_LABEL_NAME {
  PACKAGE_ID = "Package Id",
  SHIPMENT_CLIENT_NAME = "Client",
  PARCEL_CENTER_LOCATION_NAME = "Parcel Center",
  FDP_COMPANY_NAME = "FDP",
  SERVICE_TYPE_NAME = "Service Type",
  FDP_ID = "FDP ID",
  SHIPMENT_EXTERNAL_PARTNER_SHIPMENT_ID = "Shipment External Partner Shipment ID",
  SHIPMENT_EXTERNAL_ORDER_ID = "Shipment External Order ID",
  TRACKING_NUMBER = "Tracking Number",
  BAR_CODE = "Bar Code",
  RECEIVED_DATE = "Manifest Received Date",
  PLANNED_DELIVERY_DATE = "Planned Delivery Date",
  PARCEL_ARRIVAL_DATE = "Actual Arrival Date",
  DELIVERY_DATE = "Scheduled Delivery Date",
  TWO_MAN = "Two Man",
  DESKTOP = "Desktop",
  SHIPMENT_DELIVERY_INSTRUCTIONS = "Delivery Instructions",
  SHIPMENT_RECIPIENT_ADDRESS_TYPE = "Address Type",
  SIGNATURE_REQUIRED = "Signature Required",
  SHIPMENT_RECIPIENT_NAME = "Recipient Name",
  SHIPMENT_RECIPIENT_PHONE = "Recipient Phone",
  SHIPMENT_RECIPIENT_ADDRESSLINE_1 = "Recipient Address 1",
  SHIPMENT_RECIPIENT_ADDRESSLINE_2 = "Recipient Address 2",
  SHIPMENT_RECIPIENT_CITY = "Recipient City",
  SHIPMENT_RECIPIENT_STATE = "Recipient State",
  SHIPMENT_RECIPIENT_ZIP = "Recipient Zip",
  PACKAGE_VOLUME = "Package Volume",
  PACKAGE_LENGTH = "Package Length",
  PACKAGE_WIDTH = "Package Width",
  PACKAGE_HEIGHT = "Package Height",
  PACKAGE_WEIGHT = "Package Weight",
  PACKAGE_CONTENTS = "Package Contents",
  STATUS_DATE = "Status Date",
  STATUS = "Status",
  SHIPMENT_ID = "Shipment ID",
  PARCEL_CENTER_ID = "FDC Parcel Center ID",
  SHIPMENT_CLIENT_ID = "Client ID",
  CREATED_ON = "Created On",
  CREATED_BY = "Created By",
  UPDATED_ON = "Updated On",
  UPDATED_BY = "Updated By",
}

export const PACKAGE_FILTER_COLUMN_OPTIONS = [
  {
    label: PACKAGE_LABEL_NAME.SHIPMENT_CLIENT_NAME,
    value: PACKAGE_COLUMN_NAME.SHIPMENT_CLIENT_NAME,
  },
  {
    label: PACKAGE_LABEL_NAME.PARCEL_CENTER_LOCATION_NAME,
    value: PACKAGE_COLUMN_NAME.PARCEL_CENTER_LOCATION_NAME,
  },
  {
    label: PACKAGE_LABEL_NAME.FDP_COMPANY_NAME,
    value: PACKAGE_COLUMN_NAME.FDP_COMPANY_NAME,
  },
  {
    label: PACKAGE_LABEL_NAME.SERVICE_TYPE_NAME,
    value: PACKAGE_COLUMN_NAME.SERVICE_TYPE_NAME,
  },
  {
    label: PACKAGE_LABEL_NAME.FDP_ID,
    value: PACKAGE_COLUMN_NAME.FDP_ID,
  },
  {
    label: PACKAGE_LABEL_NAME.STATUS,
    value: PACKAGE_COLUMN_NAME.STATUS,
  },
  {
    label: PACKAGE_LABEL_NAME.RECEIVED_DATE,
    value: PACKAGE_COLUMN_NAME.RECEIVED_DATE,
  },
  {
    label: PACKAGE_LABEL_NAME.PLANNED_DELIVERY_DATE,
    value: PACKAGE_COLUMN_NAME.PLANNED_DELIVERY_DATE,
  },
  {
    label: PACKAGE_LABEL_NAME.PARCEL_ARRIVAL_DATE,
    value: PACKAGE_COLUMN_NAME.PARCEL_ARRIVAL_DATE,
  },
  {
    label: PACKAGE_LABEL_NAME.DELIVERY_DATE,
    value: PACKAGE_COLUMN_NAME.DELIVERY_DATE,
  },
  {
    label: PACKAGE_LABEL_NAME.PACKAGE_VOLUME,
    value: PACKAGE_COLUMN_NAME.PACKAGE_VOLUME,
  },
  {
    label: PACKAGE_LABEL_NAME.PACKAGE_WEIGHT,
    value: PACKAGE_COLUMN_NAME.PACKAGE_WEIGHT,
  },
  {
    label: PACKAGE_LABEL_NAME.TWO_MAN,
    value: PACKAGE_COLUMN_NAME.TWO_MAN,
  },
  {
    label: PACKAGE_LABEL_NAME.SHIPMENT_RECIPIENT_NAME,
    value: PACKAGE_COLUMN_NAME.SHIPMENT_RECIPIENT_NAME,
  },
  {
    label: PACKAGE_LABEL_NAME.SHIPMENT_RECIPIENT_ADDRESSLINE_1,
    value: PACKAGE_COLUMN_NAME.SHIPMENT_RECIPIENT_ADDRESSLINE_1,
  },
  {
    label: PACKAGE_LABEL_NAME.SHIPMENT_RECIPIENT_ADDRESSLINE_2,
    value: PACKAGE_COLUMN_NAME.SHIPMENT_RECIPIENT_ADDRESSLINE_2,
  },
  {
    label: PACKAGE_LABEL_NAME.SHIPMENT_RECIPIENT_CITY,
    value: PACKAGE_COLUMN_NAME.SHIPMENT_RECIPIENT_CITY,
  },
  {
    label: PACKAGE_LABEL_NAME.SHIPMENT_RECIPIENT_STATE,
    value: PACKAGE_COLUMN_NAME.SHIPMENT_RECIPIENT_STATE,
  },
  {
    label: PACKAGE_LABEL_NAME.SHIPMENT_RECIPIENT_ZIP,
    value: PACKAGE_COLUMN_NAME.SHIPMENT_RECIPIENT_ZIP,
  },
  {
    label: PACKAGE_LABEL_NAME.SHIPMENT_EXTERNAL_PARTNER_SHIPMENT_ID,
    value: PACKAGE_COLUMN_NAME.SHIPMENT_EXTERNAL_PARTNER_SHIPMENT_ID,
  },
  {
    label: PACKAGE_LABEL_NAME.PARCEL_CENTER_ID,
    value: PACKAGE_COLUMN_NAME.PARCEL_CENTER_ID,
  },

  // {
  //   label: PACKAGE_LABEL_NAME.SHIPMENT_EXTERNAL_ORDER_ID,
  //   value: PACKAGE_COLUMN_NAME.SHIPMENT_EXTERNAL_ORDER_ID,
  // },
  // {
  //   label: PACKAGE_LABEL_NAME.BAR_CODE,
  //   value: PACKAGE_COLUMN_NAME.BAR_CODE,
  // },
  // {
  //   label: PACKAGE_LABEL_NAME.DESKTOP,
  //   value: PACKAGE_COLUMN_NAME.DESKTOP,
  // },
  // {
  //   label: PACKAGE_LABEL_NAME.SHIPMENT_DELIVERY_INSTRUCTIONS,
  //   value: PACKAGE_COLUMN_NAME.SHIPMENT_DELIVERY_INSTRUCTIONS,
  // },
  // {
  //   label: PACKAGE_LABEL_NAME.SHIPMENT_RECIPIENT_ADDRESS_TYPE,
  //   value: PACKAGE_COLUMN_NAME.SHIPMENT_RECIPIENT_ADDRESS_TYPE,
  // },
  // {
  //   label: PACKAGE_LABEL_NAME.SIGNATURE_REQUIRED,
  //   value: PACKAGE_COLUMN_NAME.SIGNATURE_REQUIRED,
  // },
  // {
  //   label: PACKAGE_LABEL_NAME.SHIPMENT_RECIPIENT_PHONE,
  //   value: PACKAGE_COLUMN_NAME.SHIPMENT_RECIPIENT_PHONE,
  // },
  // {
  //   label: PACKAGE_LABEL_NAME.PACKAGE_LENGTH,
  //   value: PACKAGE_COLUMN_NAME.PACKAGE_LENGTH,
  // },
  // {
  //   label: PACKAGE_LABEL_NAME.PACKAGE_WIDTH,
  //   value: PACKAGE_COLUMN_NAME.PACKAGE_WIDTH,
  // },
  // {
  //   label: PACKAGE_LABEL_NAME.PACKAGE_HEIGHT,
  //   value: PACKAGE_COLUMN_NAME.PACKAGE_HEIGHT,
  // },
  // {
  //   label: PACKAGE_LABEL_NAME.PACKAGE_CONTENTS,
  //   value: PACKAGE_COLUMN_NAME.PACKAGE_CONTENTS,
  // },
  // {
  //   label: PACKAGE_LABEL_NAME.STATUS_DATE,
  //   value: PACKAGE_COLUMN_NAME.STATUS_DATE,
  // },
  // {
  //   label: PACKAGE_LABEL_NAME.SHIPMENT_ID,
  //   value: PACKAGE_COLUMN_NAME.SHIPMENT_ID,
  // },
  // {
  //   label: PACKAGE_LABEL_NAME.SHIPMENT_CLIENT_ID,
  //   value: PACKAGE_COLUMN_NAME.SHIPMENT_CLIENT_ID,
  // },
  // {
  //   label: PACKAGE_LABEL_NAME.CREATED_ON,
  //   value: PACKAGE_COLUMN_NAME.CREATED_ON,
  // },
  // {
  //   label: PACKAGE_LABEL_NAME.CREATED_BY,
  //   value: PACKAGE_COLUMN_NAME.CREATED_BY,
  // },
  // {
  //   label: PACKAGE_LABEL_NAME.UPDATED_ON,
  //   value: PACKAGE_COLUMN_NAME.UPDATED_ON,
  // },
  // {
  //   label: PACKAGE_LABEL_NAME.UPDATED_BY,
  //   value: PACKAGE_COLUMN_NAME.UPDATED_BY,
  // },
];
